export default __webpack_public_path__ + "images/NoDataLetterBox.7173b72ef68fe51bbea0541cd402381b.svg";